"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyEventListener = void 0;
var react_1 = require("react");
var useKeyEventListener = function (onKeyDown, onKeyUp) {
    (0, react_1.useEffect)(function () {
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
        return function () {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('keyup', onKeyUp);
        };
    }, [onKeyDown, onKeyUp]);
};
exports.useKeyEventListener = useKeyEventListener;
